import Decimal from "decimal.js";

export function decimalToPriceString({value}) {
  const decimal = new Decimal(value);
  const priceString = decimal.toFixed(2);
  return priceString.replace(".", ",");
}
